import { FlatItem } from '@martech-solution/utils/types';
import { ITaskActivity, TaskActivityAdd } from './taskActivity.type';

export interface IJobTask {
  id: number | string;
  jobCategoryId: number;
  jobTaskCode: string;
  name: string;
  nameEn: string;
  description: string;
  isActive: boolean;
  jobTaskType: EJobTaskTypeEnum;

  jobCategory: FlatItem;

  taskActivities: ITaskActivity[];
}

export type JobTaskAdd = Partial<
  Omit<IJobTask, 'taskActivities'> & {
    taskActivities: TaskActivityAdd[];
  }
>;

export enum EJobTaskTypeEnum {
  PersonalTask = 1,
  ProcessTask = 2
}
